/* eslint-disable no-underscore-dangle */
/**
 * The id of a partner or operator, whichever spelling the record carries.
 *
 * Partners and operators live in DynamoDB, where the hash key is `Id` — the
 * dashboard endpoints hand that through untouched. The partner pickers only
 * read `id`/`_id`, so every option rendered with `value={undefined}` and the
 * browser fell back to using the option's TEXT as its value: picking "Inpe
 * Consulting Malaga" set the counterparty to that name, the outstanding-lines
 * lookup found nothing for it, and the allocation could never be submitted.
 */
export default function counterpartyIdOf(entity) {
  if (!entity) return '';
  return entity.Id || entity.id || entity._id || '';
}
